import React from 'react'
import VideoPlayer from '../videoPlayer'
import Header from '../header'
export default function OverlayLayout({location, children }) {
    return (
        <>
            <Header  location={location} />
            {children}
        </>

    )
}
